module.exports = __webpack_public_path__ + "kudos_78.svg?3af2e0e2df5b7039f831bf4cdee0955e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_78.svg
// module id = 181
// module chunks = 0